import axios from 'axios';
import { storage } from '../../../helpers';
import { API_URL } from '../../../config';
import { MESSAGE } from '../../../constants';

export const processDocument = async (documentData) => {
    const token = storage.getToken();

  try {
    const response = await axios.post(
      `${API_URL}/documents/process`,
      documentData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error(MESSAGE.PROCESS.error, error);
    throw error; 
  }
};

export const updateDocument = async (documentData) => {
  const token = storage.getToken();

  try{
    const response = await axios.put(
      `${API_URL}/documents/process`,
      documentData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(MESSAGE.PROCESS.error, error);
    throw error;
  }
}
